import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
    Box, Card, CardActions, CardContent,
    CardMedia, Container, Grid, Pagination, PaginationItem, Stack
} from "@mui/material";
import Button from "@mui/material/Button";
import moment from "moment";
import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import bannerRightmb from "../../assets/images/webinar/banner-right-mb.png";
import bannerRight from "../../assets/images/webinar/banner-right.png";
import "./index.less";

export default function Event() {
    const isDesktopOrLaptop = useMediaQuery({
        query: "(min-width: 1200px)",
    });
    const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1200px)" });
    const classCategory = [
        "全部",
        "城市課堂",
        "技術培訓",
        "行業沙龍",
        "新版本介紹會",
    ];
    const classTag = ["全部", "FineReport", "FineBI", "阿米巴"];

    const oldList = [
        {
            title: "FineBI進階課程：AARRR分析",
            thumbnail: "https://www.finereport.com/tw/wp-content/uploads/2022/12/wecom-temp-240974-986486050ad3ce380967b3271bbbc2ad.jpg",
            speaker: "Teddy",
            videoLink:"https://youtu.be/lb8XB-izRv8",
        },
        {
            title: "FineBI進階課程：RFM客戶分析模型",
            thumbnail: "https://www.finereport.com/tw/wp-content/uploads/2022/12/wecom-temp-254717-2cb234255d69a43535ae856a93c77923.jpg",
            speaker: "Teddy",
            videoLink:"https://youtu.be/D6OLJWiGdEY",
        },
        {
            
            title: "FineBI進階課程： 購物籃分析模型",
            thumbnail: "https://www.finereport.com/tw/wp-content/uploads/2022/12/wecom-temp-255516-9d8858ba8ddc4865f77ff1e75740eddb.jpg",
            speaker: "Teddy",
            videoLink:"https://youtu.be/HJCQ4Ikb8es",
        },
        {
            title: "FineBI進階課程：數據分析模型",     
            thumbnail: "https://www.finereport.com/tw/wp-content/uploads/2022/12/wecom-temp-253579-2b4754322e14a128fd7ca5d4ec78173b.jpg",  
            speaker: "Teddy",
            videoLink:"https://youtu.be/tycuBb1ISlU",
        },
    ];
    const [classList, setClassList] = useState([
         {
            title: "FineReport填報基礎應用",
            class: "城市課堂",
            tag: "FineReport",
            location: "線上",
            time: "2023-06-30(五) 13:30-16:30",
            url: "https://community.finereport.com/CityClass.php?class=50",
         },
         {
            title: "FineBI基礎入門-相關與分佈",
            class: "城市課堂",
            tag: "FineBI",
            location: "線上",
            time: "2023-06-16(五) 13:30-15:30",
            url: "https://community.finereport.com/CityClass.php?class=49",
        },
        {
            title: "FineBI進階課程-數據分析模型",
            class: "城市課堂",
            tag: "FineBI",
            location: "線下",
            time: "2023-06-09(五) 13:30-16:30",
            url: "https://community.finereport.com/CityClass.php?class=48",
        },
        {
            title: "如何用FineReport實現設備日報場景？",
            class: "城市課堂",
            tag: "FineReport",
            location: "線下",
            time: "2023-05-26(五) 13:30-16:30",
            url: "https://community.finereport.com/CityClass.php?class=47",
        },
        {
            title: "FineBI基礎入門-比較與趨勢",
            class: "城市課堂",
            tag: "FineBI",
            location: "線上",
            time: "2023-05-19(五) 13:30-15:30",
            url: "https://community.finereport.com/CityClass.php?class=46",
        },
        {
            title: "FineReport報表統計動態運算（層次坐標）",
            class: "城市課堂",
            tag: "FineReport",
            location: "線上",
            time: "2023-05-12(五) 13:30-16:30",
            url: "https://community.finereport.com/CityClass.php?class=45",
        },
        {
            title: "FineReport圖表聯動應用",
            class: "城市課堂",
            tag: "FineReport",
            location: "線上",
            time: "2023-04-28(五) 13:30-16:30",
            url: "https://community.finereport.com/CityClass.php?class=44",
        },
        {
            title: "FineBI基礎入門-單個數量與組成占比",
            class: "城市課堂",
            tag: "FineBI",
            location: "線上",
            time: "2023-04-21(五) 13:30-15:30",
            url: "https://community.finereport.com/CityClass.php?class=43",
        },
        {
            title: "FineBI基礎入門-表格製作",
            class: "城市課堂",
            tag: "FineBI",
            location: "線上",
            time: "2023-03-31(五) 13:30-15:30",
            url: "https://community.finereport.com/CityClass.php?class=42",
        },
        {
            title: "FineReport報表開發-參數基礎應用",
            class: "城市課堂",
            tag: "FineReport",
            location: "線上",
            time: "2023-03-10(五) 13:30-16:30",
            url: "https://community.finereport.com/CityClass.php?class=41",
        },
        {
            title: "FineReport報表基礎應用（適用FineReport11.0版本）",
            class: "城市課堂",
            tag: "FineReport",
            location: "線上",
            time: "2023-02-24(五) 13:30-16:30",
            url: "https://community.finereport.com/CityClass.php?class=40",
        },
        {
            title: "帆軟線上課堂-FineBI基礎入門-銷售分析",
            class: "城市課堂",
            tag: "FineBI",
            location: "線上",
            time: "2023-02-17(五) 13:30-15:30",
            url: "https://community.finereport.com/CityClass.php?class=39",
        },
        {
            title: "帆軟缐上課堂 - 財務經營指標分析",
            class: "产品直播",
            tag: "FineReport",
            location: "線上",
            time: "2022-12-23(五) 15:00-16:30",
            url: "https://community.finereport.com/activity_register.php?id=20&activity=3",
        },
        {
            title: "帆軟線上沙龍-數字先鋒─稅務智慧管理",
            class: "行業沙龍",
            tag: "",
            location: "線上",
            time: "2022-12-21(三) 14:00-15:30",
            url: "https://community.finereport.com/activity_register.php?id=19&activity=4",
        },
        {
            title: "FineBI進階課程-數據處理與分析",
            class: "城市課堂",
            tag: "FineBI",
            location: "線上",
            time: "2022-12-08(四) 13:30-15:00",
            url: "https://community.finereport.com/CityClass.php?class=38",
        },
        {
            title: "年度報告為什麼這麼難做，因為你沒用 FineReport！",
            class: "产品直播",
            tag: "FineReport",
            location: "線上",
            time: "2022-11-25(五) 15:00-16:30",
            url: "https://community.finereport.com/activity_register.php?id=18&activity=3",
        },
        {
            title: "FineReport報表設計（適用FineReport11.0版本）",
            class: "城市課堂",
            tag: "FineReport",
            location: "線上",
            time: "2022-11-11(五) 13:30-16:30",
            url: "https://community.finereport.com/CityClass.php?class=37",
        },
        {
            title: "如何用 FineReport 實現設備巡檢（行動版）？",
            class: "产品直播",
            tag: "FineReport",
            location: "線上",
            time: "2022-11-04(五) 13:30-16:30",
            url: "https://community.finereport.com/activity_register.php?id=17&activity=3",
        },
        {
            title: "FineReport報表填報-行動版",
            class: "城市課堂",
            tag: "FineReport",
            location: "線上",
            time: "2022-10-21(五) 13:30-16:30",
            url: "https://community.finereport.com/CityClass.php?class=36",
        },
        {
            title: "FineBI進階課程：數據分析模型",
            class: "城市課堂",
            tag: "FineBI",
            location: "線上",
            time: "2022-10-14(五) 13:30-15:00",
            url: "https://community.finereport.com/CityClass.php?class=35",
        },
        {
            title: " 如何用FineReport實現設備日報場景",
            class: "产品直播",
            tag: " FineReport",
            location: "線上",
            time: "2022-09-30(五) 15:00-16:30",
            url: "https://community.finereport.com/activity_register.php?id=16&activity=3",
        },
        {
            title: "FineBI基礎入門：位置分佈類型圖表",
            class: "城市課堂",
            tag: "FineBI",
            location: "線上",
            time: "2022-09-23(五) 13:30-15:00",
            url: "https://community.finereport.com/CityClass.php?class=33",
        },
        {
            title: "報表統計動態運算（適用11.0.4以上版本）",
            class: "城市課堂",
            tag: "Finereport",
            location: "線上",
            time: "2022-09-16(五) 13:30-16:30",
            url: "https://community.finereport.com/CityClass.php?class=32",
        },
        {
            title: "FineReport之戰情室快速製作",
            class: "产品直播",
            tag: "Finereport",
            location: "線上",
            time: "2022-08-31(三) 14:30-16:30",
            url: "https://community.finereport.com/activity_register.php?id=14&activity=3",
        },
        {
            title: "FineBI進階課程:購物籃分析模型",
            class: "城市課堂",
            tag: "FineBI",
            location: "線上",
            time: "2022-08-26(五) 13:30-15:00",
            url: "https://community.finereport.com/CityClass.php?class=31",
        },
        {
            title: "FineBI基礎入門-相關性",
            class: "城市課堂",
            tag: "FineBI",
            location: "線上",
            time: "2022-08-19(五) 13:30-15:00",
            url: "https://community.finereport.com/CityClass.php?class=30",
        },
        {
            title: "FineReport報表設計（適用FineReport11.0版本）",
            class: "城市課堂",
            tag: "Finereport",
            location: "線上",
            time: "2022-08-12(五) 13:30-16:30",
            url: "https://community.finereport.com/CityClass.php?class=29",
        },
        {
            title: "FineReport 11.0.6 新版本發佈會",
            class: "产品直播",
            tag: "Finereport",
            location: "線上",
            time: "2022-08-04(四) 15:00-16:30",
            url: "https://community.finereport.com/activity_register.php?id=13&activity=3",
        },
        {
            title: "FineBI進階課程：RFM客戶分析模型",
            class: "城市課堂",
            tag: "FineBI",
            location: "線上",
            time: "2022-07-29(五) 13:30-15:00",
            url: "https://community.finereport.com/CityClass.php?class=28",
        },
        {
            title: "FineBI基礎入門：單個數量與組成佔比",
            class: "城市課堂",
            tag: "FineBI",
            location: "線上",
            time: "2022-07-22(五) 13:30-15:00",
            url: "https://community.finereport.com/CityClass.php?class=27",
        },
        {
            title: "FineReport報表開發：參數應用",
            class: "城市課堂",
            tag: "Finereport",
            location: "線上",
            time: "2022-07-15(五) 13:30-16:30",
            url: "https://community.finereport.com/CityClass.php?class=26",
        },
        {
            title: "FineBI基礎入門：柱形與折線圖製作",
            class: "城市課堂",
            tag: "FineBI",
            location: "線上",
            time: "2022-06-24(五) 13:30-15:00",
            url: "https://community.finereport.com/CityClass.php?class=25",
        },
        {
            title: "FineBI基礎入門：表格製作",
            class: "城市課堂",
            tag: "FineBI",
            location: "線上",
            time: "2022-06-17(五) 13:30-15:00",
            url: "https://community.finereport.com/CityClass.php?class=24",
        },{
            title: "FineReport決策報表基礎入門",
            class: "城市課堂",
            tag: "Finereport",
            location: "線上",
            time: "2022-06-10(五) 13:30-16:30",
            url: "https://community.finereport.com/CityClass.php?class=23",
        },
        {
            title: "FineBI進階課程：AARRR分析",
            class: "城市課堂",
            tag: "FineBI",
            location: "線上",
            time: "2022-05-27(五) 13:30-16:30",
            url: "https://community.finereport.com/CityClass.php?class=22",
        },
        {
            title: "FineReport決策報表應用",
            class: "城市課堂",
            tag: "Finereport",
            location: "線上",
            time: "2022-05-13(五) 13:30-16:30",
            url: "https://community.finereport.com/CityClass.php?class=21",
        },
        {
            title: "FineBI進階課程：COVID-19疫情分析戰情室",
            class: "城市課堂",
            tag: "FineBI",
            location: "線上",
            time: "2022-04-29(五) 13:30-16:30",
            url: "https://community.finereport.com/CityClass.php?class=20",
        },
        {
            title: " 阿米巴經營價值建構",
            class: "行業沙龍",
            tag: "阿米巴",
            location: "線上",
            time: "2022-04-27(三) 14:00-16:00",
            url: "https://community.finereport.com/activity_register.php?id=12&activity=4",
        },
        {
            title: "FineReport新版本11.0.3發佈會",
            class: "產品直播",
            tag: "Finereport",
            location: "線上",
            time: "2022-04-22(五) 15:00-16:00",
            url: "https://community.finereport.com/CityClass.php?class=19",
        },
        {
            title: "FineReport決策報表應用",
            class: "城市課堂",
            tag: "Finereport",
            location: "線上",
            time: "2022-04-15(五) 13:30-16:30",
            url: "https://community.finereport.com/CityClass.php?class=18",
        },

        {
            title: "帆軟數致不凡 - 智造⁺行業沙龍直播",
            class: "行業沙龍",
            tag: "阿米巴",
            location: "線上",
            time: "2022-04-01(五) 14:00-16:00",
            url: "https://rvcp2u85rs.jiandaoyun.com/f/622ad99066d85e00079b2faf",
        },
        {
            title: "FineBI基礎入門(四)",
            class: "城市課堂",
            tag: "FineBI",
            location: "線上",
            time: "2022-03-31(四) 13:30-16:30",
            url: "https://community.finereport.com/CityClass.php?class=17",
        },
        {
            title: "帆軟數友匯 - 阿米巴經營價值建構",
            class: "行業沙龍",
            tag: "",
            location: "線上",
            time: "2022-03-25(五) 13:30-17:00",
            url: "https://community.finereport.com/activity_register.php?id=10&activity=4",
        },
        {
            title: "FineReport報表統計動態運算",
            class: "城市課堂",
            tag: "FineReport",
            location: "線上",
            time: "2022-03-11(五) 13:30-16:30",
            url: "https://community.finereport.com/CityClass.php?class=16",
        },
        {
            title: "FineReport報表設計入門",
            class: "城市課堂",
            tag: "FineReport",
            location: "線上",
            time: "2022-02-18(五) 13:30-16:30",
            url: "https://community.finereport.com/CityClass.php?class=15",
        },
        {
            title: "從FineReport資料匯入到FineBI資料呈現的實戰演練",
            class: "城市課堂",
            tag: "FineReport,FineBI",
            location: "線上",
            time: "2022-01-26(三) 13:30-16:30",
            url: "https://community.finereport.com/CityClass.php?class=14",
        },
        {
            title: "FineBI基礎入門（三）",
            class: "城市課堂",
            tag: "FineBI",
            location: "線上",
            time: "2022-01-13(四) 13:30-16:30",
            url: "https://community.finereport.com/CityClass.php?class=13",
        },
        {
            title: "FineReport報表設計入門",
            class: "城市課堂",
            tag: "FineReport",
            location: "線上",
            time: "2021-12-30(四) 13:30-16:30",
            url: "https://community.finereport.com/CityClass.php?class=12",
        },
        {
            title: "FineBI基礎入門（二）",
            class: "城市課堂",
            tag: "FineBI",
            location: "線上",
            time: "2021-12-17(五) 13:30-16:30",
            url: "https://community.finereport.com/CityClass.php?class=11",
        },
        {
            title: "FineReport圖表常見問題教學",
            class: "技術培訓",
            tag: "FineReport",
            location: "線上",
            time: "2021-11-30(二) 15:00-16:00",
            url: "https://community.finereport.com/activity_register.php?id=9&activity=3",
        },
        {
            title: "FineReport報表設計入門",
            class: "城市課堂",
            tag: "FineReport",
            location: "線上",
            time: "2021-11-19(五) 13:30-16:30",
            url: "https://community.finereport.com/activity_register.php?id=8&activity=3",
        },
        {
            title: "FineBI&FineReport銷售分析與業績考核",
            class: "城市課堂",
            tag: "FineReport, FineBI",
            location: "線上",
            time: "2021-11-12(五) 13:30-16:30",
            url: "https://community.finereport.com/CityClass.php?class=10",
        },
        {
            title: "帆軟阿米巴經營管理，如何助力企業落地實踐阿米巴、組織創造價值",
            class: "行業沙龍",
            tag: "阿米巴",
            location: "線上",
            time: "2021-11-10(三) 14:00-16:00",
            url: "https://community.finereport.com/activity_register.php?id=7&activity=3",
        },
        {
            title: "銀行商業智能生態建設案例分享",
            class: "行業沙龍",
            tag: "FineReport, FineBI",
            location: "線上",
            time: "2021-11-03(三) 14:00-16:00",
            url: "https://community.finereport.com/CityClass.php?class=9",
        },
        {
            title: "FineBI零基礎入門",
            class: "城市課堂",
            tag: "FineBI",
            location: "線上",
            time: "2021-10-22(五) 13:30-16:30",
            url: "https://community.finereport.com/activity_register.php?id=6&activity=3",
        },
        {
            title: "FineReport報表填報基礎應用",
            class: "城市課堂",
            tag: "FineReport",
            location: "線上",
            time: "2021-10-15(五) 13:30-16:30",
            url: "https://community.finereport.com/CityClass.php?class=8",
        },
        {
            title: "世界500強都在用的經營手法─阿米巴經營管理",
            class: "行業沙龍",
            tag: "阿米巴",
            location: "線上",
            time: "2021-10-13(三) 14:00-17:00",
            url: "https://community.finereport.com/activity_register.php?id=5&activity=3",
        },
        {
            title: "FineReport系統運維之伺服器配置建議",
            class: "技術培訓",
            tag: "FineReport",
            location: "線上",
            time: "2021-09-29(三) 14:00-15:00",
            url: "https://community.finereport.com/activity_register.php?id=4&activity=3",
        },
        {
            title: "FineBI數據分析實戰：AARRR可視化分析報告",
            class: "城市課堂",
            tag: "FineBI",
            location: "線上",
            time: "2021-09-24(五) 13:30-16:30",
            url: "https://community.finereport.com/CityClass.php?class=7",
        },
        {
            title: "FineReport新版本發佈會 - 五大海外特色新功能教學",
            class: "新版本介紹會",
            tag: "FineReport",
            location: "線上",
            time: "2021-09-15(三) 15:00-16:00",
            url: "https://community.finereport.com/activity_register.php?id=3&activity=3",
        },
        {
            title: "FineBI零基礎入門：Covid19 Dashboard製作",
            class: "城市課堂",
            tag: "FineBI",
            location: "線上",
            time: "2021-09-03(五) 13:30-16:30",
            url: "https://community.finereport.com/activity_register.php?id=2&activity=3",
        },
        {
            title: "視覺化教學：利用Excel資料製作超炫酷的Dashboard",
            class: "城市課堂",
            tag: "FineReport",
            location: "線上",
            time: "2021-08-27(五) 13:30-16:30",
            url: "https://community.finereport.com/CityClass.php?class=6",
        },
        {
            title: "FineReport技術專家分享會——三招教你解決產品使用中的問題",
            class: "技術培訓",
            tag: "FineReport",
            location: "線上",
            time: "2021-08-20(五) 15:00-16:00",
            url: "https://community.finereport.com/activity_register.php?id=1&activity=3",
        },
        {
            title: "FineReport報表開發-參數應用",
            class: "城市課堂",
            tag: "FineReport",
            location: "線上",
            time: "2021-08-13(五) 13:30-16:30",
            url: "https://community.finereport.com/CityClass.php?class=5",
        },
        {
            title: "數據大屏設計入門——寵物認領養看板",
            class: "城市課堂",
            tag: "FineReport",
            location: "線上",
            time: "2021-07-30(五) 13:30-16:30",
            url: "https://community.finereport.com/CityClass.php?class=4",
        },
        {
            title: "FineReport報表統計動態運算",
            class: "城市課堂",
            tag: "FineReport",
            location: "線上",
            time: "2021-07-02(五) 13:30-16:30",
            url: "https://community.finereport.com/CityClass.php?class=3",
        },
        {
            title: "FineReport報表設計入門",
            class: "城市課堂",
            tag: "FineReport",
            location: "線上",
            time: "2021-05-28(五) 13:30-16:30",
            url: "https://community.finereport.com/CityClass.php?class=2",
        },
    ]);

    const [title, setTitle] = useState("FineReport 課程&活動");
    const [expandCategory, setExpandCategory] = useState(true);
    const [expandTag, setExpandTag] = useState(false);
    const [category, setCategory] = useState("全部");
    const [tag, setTag] = useState("全部");
    const [classItems, setClassItems] = useState(classList);
    const [page, setPage] = useState(0);
    const [pages, setPages] = useState(Math.ceil(classItems.length / 4));

    const oldpages = Math.ceil(oldList.length / 8);

    //点击收藏按钮
    const handlePageClick = (event, number) => {
        setPage(number - 1);
    };
    const handlesBlur = (event) => {
        setExpandTag(false);
        setExpandCategory(false);
    };
    const selectExpandLeft = (event) => {
        setExpandCategory(!expandCategory);
        if (expandTag) {
            setExpandTag(false);
        }
    };
    const selectExpandRight = (event) => {
        setExpandTag(!expandTag);
        if (expandCategory) {
            setExpandCategory(false);
        }
    };

    const handleSelectCategory = (e, props) => {
        let ele = e.target;
        if (ele.nodeName === "BUTTON") {
            setCategory(ele.textContent.trim());
        } else {
            setCategory(ele.getAttribute("value"));

            handlesBlur(e);
        }
    };
    const handleSelectTag = (e, props) => {
        let ele = e.target;
        if (ele.nodeName === "BUTTON") {
            setTag(ele.textContent.trim());
        } else {
            setTag(ele.getAttribute("value"));
            handlesBlur(e);
        }
    };
    const handleTime = (classItem) => {
        var month = moment(classItem.time, "YYYY-MM-DD").format("M");
        var day = moment(classItem.time, "YYYY-MM-DD").format("D");
        var time = moment(classItem.time, "YYYY-MM-DD HH:mm");
        // let time = moment("12-30-2021", "MM-DD-YYYY");
        return {
            month: month,
            day: day,
            time: time,
        };
    };

    const classRender = (classList) => {
        const classListDom = classList.map((classItem, index) => {
            let { month, day, time } = handleTime(classItem);
            let now = moment();
            let timeout = now.isBefore(time);
            return ( 
                <Grid container columns = { 16 } >
                
                    <Grid item xs = { 2 } >
                
                        <Box sx = {
                            {
                                backgroundColor: "#0082FC",
                                color: "#fff",
                                textAlign: "center",
                                width: "88px",
                                borderRadius: "4px",
                            }
                        } >
                            <div style = {
                                {
                                    backgroundColor: "#61A2FF",
                                    paddingBlock: "5px",
                                    fontSize: "16px",
                                    borderRadius: "4px 4px 0px 0px",
                                }
                            } > { month }
                            月 
                            </div>
                            <div style = {
                                { fontSize: "32px", paddingBlock: "5px" }
                            } > { day } 
                            </div> 
                        </Box> 
                    </Grid>
                    <Grid item xs sx = {
                        { marginTop: "12px" }
                    } >
                        <Stack>
                            <p style = {
                                {
                                    margin: 0,
                                    fontSize: "18px",
                                    fontWeight: 600,
                                    fontFamily: "inherit",
                                    marginBottom: "20px",
                                }
                            } > { classItem.title } </p> 
                            <Stack direction = "row" spacing = "60px">
                                <div> 活動類型： { classItem.class } </div> 
                                <div> 活動地點： { classItem.location } </div>
                                <div> 活動時間： { classItem.time } </div> 
                            </Stack> 
                        </Stack> 
                    </Grid> 
                    <Grid item xs = { 2 }
                    sx = {
                        { marginTop: "12px" }
                    } >
                        <Button variant = { timeout ? "contained" : "outlined" }
                        href = { classItem.url }
                        className = "register"
                        target = { "_blank" } > { timeout ? "立即報名" : "報名結束" } 
                        </Button> 
                    </Grid > 
                </Grid>
            );
        });
        return classListDom;
    };

    const oldclassRender = (oldclassList) => {
        const oldclassDom = oldclassList.map((classItem, index) => {
            return ( 
            <Grid item lg = { 3 }
                md = { 4 }
                xs = { 12 } 
                className="card_style">
                <Card style={{position:"relative"}} >
                <CardMedia component = "img"
                width = "350"
                image = { classItem.thumbnail }
                alt = "green iguana" />
                <div style = {
                    {minHeight: '146px' , padding:"0 18px" }
                }>   
                <CardContent style = {
                    {padding:"18px 0 14px 0"}
                }>
                <h3 style = {
                    { fontSize: "18px", fontWeight: "500"}
                } > { classItem.title } </h3> 
                </CardContent> 
                <div  style={{position:"absolute",bottom:"0"}}>
                <CardActions disableSpacing sx = {
                    {   width:"238px",
                        display:"flex",
                        justifyContent: "space-between",
                        fontWeight:"500",
                        color:"#8496AB"         
                }
                } >
                
                <>講師： { classItem.speaker } </>
                <><a style = {
                    { cursor:'pointer',fontWeight:"500" }
                } 
                href = {classItem.videoLink}> 回放 </a></>                 
                </CardActions >
                </div>
                </div> 
                </Card> 
                </Grid>
            );
        });
        return oldclassDom;
    };

    const classMobileRender = (classList) => {
        const clasMobileDom = classList.map((classItem, index) => {
            let { month, day, time } = handleTime(classItem);
            let now = moment();
            let timeout = now.isBefore(time);
            return ( 
                <Box sx = {
                    {
                        borderRadius: "8px",
                        boxShadow: "0px 0px 10px 0px rgba(0, 130, 252, 0.05)",
                        backgroundColor: "#fff",
                        paddingBlock: "10px",
                        paddingInline: "12px",
                    }
                } >
                
                <Grid container columns = { 12 }
                spacing = { 2 } >
                
                <Grid item sx = {
                    {
                        borderRadius: "7px",
                        color: "#fff",
                    }
                } >
                
                <div style = {
                    { width: "70px" }
                } >
                
                <div style = {
                    {
                        backgroundColor: "#61A2FF",
                        borderTopRightRadius: "7px",
                        borderTopLeftRadius: "7px",
                        paddingBlock: "4px",
                        paddingInline: "17px",
                        fontSize: "11px",
                        textAlign: "center",
                    }
                } > { month }
                月 
                </div> 
                <div style = {
                    {
                        backgroundColor: "#0082FC",
                        borderEndStartRadius: "7px",
                        borderEndEndRadius: "7px",
                        textAlign: "center",
                        fontSize: "20px",
                        paddingBlock: "4px",
                    }
                } > { day } 
                </div> 
                </div> 
                </Grid> 
                <Grid item xs >
                
                <h3 style = {
                    { marginTop: "8px", fontSize: "14px" }
                } > { classItem.title } 
                </h3> 
                </Grid> 
                </Grid> 
                <Grid container spacing = { 1 }
                sx = {
                    { marginTop: "10px" }
                } >
                
                <Grid item xs = { 8 } >
                
                <Grid container sx = {
                    { justifyContent: "space-between", fontSize: "11px" }
                } >
                
                <Grid item >
                
                <span className = "subtitle" > 活動類型 </span>：{classItem.class} 
                </Grid > 
                <Grid item >
                
                <span className = "subtitle" > 活動地點 </span>： { classItem.location } 
                </Grid> 
                </Grid> 
                <Grid container sx = {
                    { fontSize: "11px" }
                } >
                
                <span className = "subtitle" > 活動時間 </span>：{classItem.time} 
                </Grid > 
                </Grid> 
                <Grid item xs >
                
                <Button variant = { timeout ? "contained" : "outlined" }
                sx = {
                    { width: "100%", fontSize: "12px" }
                }
                href = { classItem.url }
                className = "register"
                target = "_blank" > { timeout ? "立即報名" : "報名結束" } 
                </Button> 
                </Grid> 
                </Grid> 
                </Box>
            );
        });
        return clasMobileDom;
    };
    const oldClassMobileRender = (classList) => {
        const oldClassMobileDom = classList.map((classItem, index) => {
            return ( 
                <Grid item xs = { 12 } >
                
                <Card sx = {
                    { display: "flex", boxShadow: "none" }
                } >
                
                <CardMedia component = "img"
                sx = {
                    { width: "157px", borderRadius: "4px" }
                }
                image = { classItem.thumbnail }
                alt = "green iguana" />
                
                <CardContent sx = {
                    {
                        paddingBlock: "0",
                        border: "none",
                        "&:last-child": {
                            paddingBottom: "0",
                        },
                    }
                } >
                
                <h3 style = {
                    {
                        fontSize: "15px",
                        marginBottom: "8px",
                        fontWeight: "600",
                    }
                } > { classItem.title } 
                </h3> 
                <Box sx = {
                    { paddingBottom: "0" }
                } >
                
                <p style = {
                    { marginBottom: "8px" }
                } >
                
                <span className = "subtitle" > 講師：  { classItem.speaker } </span> 
                </p> 
                <a style = {
                    { cursor:'pointer' }
                } 
                href = {classItem.videoLink}> 回放 </a> 
                </Box> 
                </CardContent> 
                </Card> 
                </Grid>
            );
        });
        return oldClassMobileDom;
    };

    useEffect(() => {
        document.title = title;
    });
    useEffect(() => {
        fetch("https://community.finereport.com/static/page.json")
            .then((res) => {
                return res.json();
            })
            .then((res) => {
                console.log(res.classList);
            })
            .catch((error) => {
                console.error("Error", error);
            });

        return () => {
            console.log("1");
        };
    });

    useEffect(() => {
        setPages(Math.ceil(classItems.length / 4));
        setPage(0);
    }, [classItems]);



    useEffect(() => {
        const listFiter = () => {
            console.log(tag, category);
            return classList.filter((item) => {
                if (tag === "全部" && category === "全部") {
                    return 1;
                }
                else if (tag === "全部" && category !== "全部") {
                    return (
                        category.toLowerCase().indexOf(item.class.toLowerCase()) !== -1 
                    );
                } else if (category === "全部" && tag !== "全部") {
                    return (
                        tag.toLowerCase().indexOf(item.tag.toLowerCase()) !== -1
                    );
                } else if(category !== "全部" && tag !== "全部") {
                    return (
                        tag.toLowerCase().indexOf(item.tag.toLowerCase()) !== -1 &&
                        category.toLowerCase().indexOf(item.class.toLowerCase()) !== -1
                    );
                } 
            });
        };
        setClassItems(listFiter());
    }, [tag, category]);




    return ( 
        <div className = "webinar" >
            
            <div className = "webinar-banner" >
            
                <Container maxWidth = "lg"
                disableGutters = { false } >
                
                    <Grid container justifyContent = "center"
                        alignItems = "center" > {
                            isDesktopOrLaptop && (
                                <>
                                
                                <Grid item sm = { 6 } >
                                
                                <h1> 課程 & 活動 </h1> 
                                <p>
                                帆軟為您提供線上線下各類豐富的教育訓練活動， 幫助您快速學習了解產品 
                                </p> 
                                </Grid> 
                                <Grid item sm = { 6 }
                                    sx = {
                                        { textAlign: "end" }
                                    } >
                                    
                                    <img className = "pc"
                                    src = { bannerRight }
                                    alt = "right" />
                                
                                </Grid>
                                </>
                            )
                        } {
                            isTabletOrMobile && (
                                <>
                                
                                <Grid item xs = { 12 }
                                sx = {
                                    { position: "relative", minHeight: "160px" }
                                } >
                                
                                <h1 className = "mb-h1" > 課程活動 </h1> 
                                <img className = "mb"
                                src = { bannerRightmb }
                                alt = "right" />
                                
                                </Grid> 
                                </>
                            )
                        } 
                    </Grid> 
                </Container > 
            </div> 
            <div className = "webinar-newclass"
            style = {
                {
                    backgroundColor: isDesktopOrLaptop ? "#fff" : "#F7F9FF",
                    position: "relative",
                }
            } >
            
            <div className = "webinar-newclass-title" >
            
            <Container maxWidth = "lg" >
            
            <h2> 最新課程 </h2> 
            </Container> 
            </div> {
            isTabletOrMobile && ( 
                <>
                
                <div style = {
                    {
                        backgroundColor: "#fff",
                        boxShadow: "2px 0px 5px 0px rgba(0, 130, 252, 0.1)",
                    }
                } >
                
                <Container maxWidth = "lg" >
                
                <Stack spacing = { 5 }
                direction = "row"
                justifyContent = "center" >
                
                <Button variant = "text"
                onFocus = {
                    (e) => selectExpandLeft(e)
                }
                endIcon = {
                    expandCategory ? < ExpandLessIcon /> : < ExpandMoreIcon />
                }
                sx = {
                    {
                        fontSize: "14px",
                        fontWeight: "500",
                        color: expandCategory ? "#0082FC" : "black",
                    }
                } > { category } 
                </Button> 
                <Button variant = "text"
                onFocus = {
                    (e) => selectExpandRight(e)
                }
                endIcon = {
                    expandTag ? < ExpandLessIcon /> : < ExpandMoreIcon />
                }
                sx = {
                    {
                        fontSize: "14px",
                        fontWeight: "500",
                        color: expandTag ? "#0082FC" : "black",
                    }
                } > { tag } 
                </Button> 
                </Stack> 
                </Container> 
                </div > 
                <div style = {
                    { marginTop: "1px", position: "relative" }
                } >
                
                <Container maxWidth = "xs"
                sx = {
                    { backgroundColor: "#fff" }
                }
                className = "selectContainer" >
                
                <div className = {expandCategory ?"select-show" : "select-hidden"} >
                
                    <ul style = {
                        { listStyle: "none" }
                    } > {
                        classCategory.map((item, index) => {
                            return ( 
                                <li key = { index }
                                value = { item }
                                onClick = {
                                    (e, props) => handleSelectCategory(e, props)
                                } > { item } </li>
                            );
                        })
                    } 
                    </ul> 
                </div> 
                <div className = { expandTag ? "select-show" : "select-hidden" } >
                
                    <ul style = {
                        { listStyle: "none" }
                    } > {
                        classTag.map((item, index) => {
                            return ( 
                                <li key = { index }
                                value = { item }
                                onClick = {
                                    (e, props) => handleSelectTag(e, props)
                                } > { item } 
                                </li>
                            );
                        })
                    } 
                    </ul> 
                </div> 
                </Container> 
                </div> 
                </>
            )
        } {
            isDesktopOrLaptop && ( 
                    <Container maxWidth = "lg"
                    sx = {
                        { marginTop: "44px" }
                    } >
                    
                    <Grid container >
                    
                    <Grid item sm = { 2 } >
                    
                        <Stack sx = {
                            { textAlign: "center", width: "120px" }
                        } >
                        
                        <h3 style = {
                            { fontSize: "18px", fontWeight: "600" }
                        } >
                        活動類型 
                        </h3> {
                        classCategory.map((item, index) => {
                            return ( 
                                <Button variant = "text"
                                key = { index }
                                onClick = {
                                    (e, props) => handleSelectCategory(e, props)
                                }
                                className = { `filter ${category === item ? "selected" : ""}` } > { item } 
                                </Button>
                            );
                        })
                    } 
                        </Stack> 
                        <Stack sx = {
                            { textAlign: "center", width: "120px" }
                        } >
                        
                        <h3 style = {
                            {
                                fontSize: "18px",
                                fontWeight: "600",
                                marginTop: "48px",
                            }
                        } >
                        活動標籤 
                        </h3> {
                    classTag.map((item, index) => {
                        return ( 
                            <Button variant = "text"
                            key = { index }
                            onClick = {
                                (e, props) => handleSelectTag(e, props)
                            }
                            className = { `filter ${tag === item ? "selected" : ""}` } > { item } 
                            </Button>
                        );
                    })
                } 
                        </Stack> 
                    </Grid > 
                    <Grid item sm = { 10 } >
        
        <Stack spacing = { 2 }
    sx = {
            { minHeight: "428px" }
        } > { classRender(classItems.slice(page * 4, (page + 1) * 4)) } 
        </Stack> 
        <Grid container justifyContent = "center"
    sx = {
            { paddingBlock: "40px" }
        } >
        
        <Pagination count = { pages }
    onChange = {
        (e, value) => handlePageClick(e, value)
    }
    shape = "rounded"
    color = "primary"
    sx = {
        {}
    }
    renderItem = {
        (item) => ( 
            <PaginationItem {...item }
            sx = {
                {
                    backgroundColor: "#fff",
                    borderRadius: "0",
                    "&.Mui-selected": {
                        backgroundColor: "#0082FC",
                    },
                }
            }
            />
        )
    }
    /> 
    </Grid> 
    </Grid> 
    </Grid> 
    </Container>
)
}

{
    isTabletOrMobile && ( <>
        
        <Container maxWidth = "md"
        sx = {
            { marginTop: "15px", position: "relative" }
        } >
        
        <div style = {
            {
                backgroundColor: "rgba(0, 0, 0, 0.4)",
                display: expandCategory || expandTag ? "flex" : "none",
                position: "absolute",
                top: "-14px",
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: "1",
            }
        } >
        
        </div> 
        <Stack spacing = { 2 } > { classMobileRender(classItems.slice(page * 4, (page + 1) * 4)) } 
        </Stack> 
        <Grid container justifyContent = "center"
        py = { 2 } >
        
        <Pagination count = { pages }
        onChange = {
            (e, value) => handlePageClick(e, value)
        }
        shape = "rounded"
        color = "primary"
        sx = {
            { justifyContent: "center" }
        }
        renderItem = {
            (item) => ( <PaginationItem {...item }
                sx = {
                    { backgroundColor: "#fff", borderRadius: "0px" }
                }
                />
            )
        }
        /> 
        </Grid >
        </Container> </>
    )
}
</div> 
{
 <div className="webinar-oldclass" style={{ position: "relative" }}>
        {/* {isTabletOrMobile && (
          <div
            style={{
              backgroundColor: "rgba(0, 0, 0, 0.4)",
              display: expandCategory || expandTag ? "flex" : "none",
              position: "absolute",
              top: "0",
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: "1",
            }}
          ></div>
        )} */}
        {isDesktopOrLaptop && (
          <Container maxWidth="lg">
            <Grid container>
              <Grid item>
                <h2>課程錄影</h2>
              </Grid>
            </Grid>
            <Grid
              container
              columnGap={3}
              sx={{ marginTop: "40px" }}
              className="webinar-oldclass-list"
            >
              {oldclassRender(oldList)}
            </Grid>
            <Grid
              container
              sx={{ justifyContent: "center", paddingBlock: "50px" }}
            >
              <Pagination
                count={oldpages}
                shape="rounded"
                color="primary"
                renderItem={(item) => (
                  <PaginationItem
                    {...item}
                    sx={{ backgroundColor: "#fff", borderRadius: "0px" }}
                  />
                )}
              />
            </Grid>
          </Container>
        )}
        {isTabletOrMobile && (
          <>
            <Grid
              container
              sx={{
                boxShadow: "0px 0px 5px 0px rgba(51, 51, 51, 0.2)",
                background: "#fff",
              }}
            >
              <Grid item py="10px">
                <Container maxWidth="lg">
                  <h2>課程錄影</h2>
                </Container>
              </Grid>
            </Grid>

            <Container
              maxWidth="lg"
              sx={{
                backgroundColor: "#fff",
                boxShadow: "0px 0px 5px 0px rgba(51, 51, 51, 0.2)",
                paddingTop: "15px",
              }}
            >
              <Grid container rowGap={3}>
                {oldClassMobileRender(oldList)}
              </Grid>
              <Grid
                container
                sx={{ justifyContent: "center", paddingBlock: "18px" }}
              >
                <Pagination
                  count={oldpages}
                  shape="rounded"
                  color="primary"
                  renderItem={(item) => (
                    <PaginationItem
                      {...item}
                      sx={{ backgroundColor: "#fff", borderRadius: "0px" }}
                    />
                  )}
                />
              </Grid>
            </Container>
          </>
        )}
      </div> 
} 
</div>
);
}
